export const environment = {
    production: false,
    apiUrl: 'https://api.totsguide.com/scopeprogramapi',
    CLIENT_ID: 'rzp_live_VE2wqTCy57C9xV',
    paymentEnabled: true,
    days: 30
};
